"use strict";

var _interopRequireDefault = require("/build-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _WorkOrderEntity = _interopRequireDefault(require("@services/WorkOrderEntity"));
var _utils = require("@/utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      innerVisible: false,
      insideHide: false,
      loading: false,
      formData: {},
      editDetailData: {},
      form: {
        fieldMsg: ''
      },
      tableData: [],
      workorder_type_id: '',
      id: '',
      configId: '',
      field: {},
      file: [],
      previewPicSrc: ''
    };
  },
  mounted: function mounted() {
    var _this = this;
    // 按下esc键关闭详情弹框
    this.$nextTick(function () {
      document.addEventListener('keyup', function (e) {
        if (e.key === 'Escape') {
          if (document.getElementsByClassName('el-image-viewer__canvas').length === 0) {
            _this.innerVisible = false;
          }
        }
      });
    });
  },
  methods: {
    // 修改内部详情
    editDetail: function editDetail(detailData) {
      if (!detailData || !detailData.includes('{')) {
        return this.$message.error(this.$t('editContentEmpty'));
      }
      var obj = (0, _utils.matchData)(this.field, detailData);
      console.log(this.field, detailData);
      console.log(obj);
      this.editDetailData = obj;
      this.insideHide = true;
    },
    // 图片预览
    srcList: function srcList(arr) {
      var imageArr = [];
      arr.map(function (item) {
        imageArr.push(item.url);
      });
      return imageArr;
    },
    open: function open(id, configId) {
      this.innerVisible = true;
      this.id = id;
      this.configId = Number(configId) === 999 ? 0 : configId;
      this.getInfo(this.id);
    },
    getInfo: function getInfo(id) {
      var _this2 = this;
      this.loading = true;
      _WorkOrderEntity.default.getWorkOrderInfo({
        id: id
      }).then(function (res) {
        var code = res.code,
          data = res.data;
        if (code === 200) {
          _this2.form = _objectSpread(_objectSpread({}, data[0]), {}, {
            fieldMsg: ''
          });
          try {
            _this2.file = JSON.parse(_this2.form.workorder_file);
            _this2.file.forEach(function (item) {
              item.fileUrl = item.url;
              var index = item.url.lastIndexOf('/');
              item.fileName = item.url.substr(index + 1);
              var reg = /\.(png|jpg|gif|jpeg|webp)$/;
              if (reg.test(item.fileUrl)) {
                item.flag = 1;
              } else {
                item.flag = 0;
              }
            });
          } catch (e) {
            _this2.file = [];
          }
          _this2.workorder_type_id = data[0].workorder_type || '';
          _this2.getFieldAttr(data[0].workorder_type || '');
        }
      }).catch();
      this.tableData = [];
      _WorkOrderEntity.default.getDealRecord({
        id: id
      }).then(function (res) {
        var data = res.data;
        _this2.tableData = data || [];
        if (_this2.tableData.length > 0 && _this2.tableData[_this2.tableData.length - 1].image_mark && _this2.tableData[_this2.tableData.length - 1].image_mark !== '[]') {
          _this2.previewPicSrc = JSON.parse(_this2.tableData[_this2.tableData.length - 1].image_mark)[0].url;
        } else {
          _this2.previewPicSrc = '';
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    getFieldAttr: function () {
      var _getFieldAttr = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(type) {
        var _this3 = this;
        var attrTableList, obj;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.field = {};
              _context.prev = 1;
              _context.next = 4;
              return this.$store.dispatch('getFieldAttrList', this.configId);
            case 4:
              attrTableList = _context.sent;
              this.field = attrTableList.attrTable[type] || '';
              obj = (0, _utils.matchData)(this.field, this.form.field_msg);
              this.$nextTick(function () {
                _this3.form.fieldMsg = obj;
                console.log(_this3.form);
              });
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              console.log(_context.t0);
            case 13:
              this.loading = false;
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 10]]);
      }));
      function getFieldAttr(_x) {
        return _getFieldAttr.apply(this, arguments);
      }
      return getFieldAttr;
    }(),
    statusTxt: function statusTxt(val) {
      var obj = {
        1: this.$t('low'),
        2: this.$t('medium'),
        3: this.$t('high'),
        4: this.$t('urgent')
      };
      return obj[val] || '';
    },
    curStatusTxt: function curStatusTxt(val) {
      var obj = {
        1: this.$t('pending'),
        2: this.$t('process'),
        3: this.$t('toBeConfirmed'),
        4: this.$t('solved'),
        5: this.$t('closed')
      };
      return obj[val] || '';
    },
    downloadIamge: function downloadIamge(imgsrc, name) {
      var image = new Image();
      image.setAttribute('crossOrigin', 'anonymous');
      image.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL('image/png');
        var a = document.createElement('a');
        var event = new MouseEvent('click');
        a.download = name || 'photo';
        a.href = url;
        a.dispatchEvent(event);
      };
      image.src = imgsrc;
    }
  }
};